export interface BuilderContentSettings {
  self_tour_scheduling_title: string;
  self_tour_scheduling_subtitle: string;
  self_tour_scheduling_description: string;
  how_it_works_title: string;
  step_1_title: string;
  step_1_description: string;
  step_2_title: string;
  step_2_description: string;
  step_3_title: string;
  step_3_description: string;
  step_4_title: string;
  step_4_description: string;
  start_touring_button: string;
  self_tours_own_time_title: string;
  tour_now_title: string;
  tour_now_description: string;
  tour_now_button: string;
  schedule_tour_title: string;
  schedule_tour_description: string;
  schedule_tour_button: string;
}

export const CONTENT_SETTINGS_DEFAULT: BuilderContentSettings = {
  self_tour_scheduling_title: "Self-tour scheduling",
  self_tour_scheduling_subtitle: "made easy!",
  self_tour_scheduling_description: "Finding your dream home is just a few steps away. Enjoy a private tour of our beautiful new homes at a time that is convenient for you.",
  how_it_works_title: "How it works",
  step_1_title: "Select the home",
  step_1_description: "Search our completed homes to see which offer self-guided tours.",
  step_2_title: "Verify identity",
  step_2_description: "Create an account with a valid ID and phone number.",
  step_3_title: "Choose the time",
  step_3_description: "Select 'Tour Now' or schedule for a later time.",
  step_4_title: "Receive access code",
  step_4_description: "At the selected time, receive an access code and enjoy your tour.",
  start_touring_button: "Start Touring",
  self_tours_own_time_title: "Self-Tours on own time",
  tour_now_title: "Tour Now! Get On-Demand Access",
  tour_now_description: "Once you are at the property, verify your identity, get a one-time use access code and enjoy your home tour!",
  tour_now_button: "Tour Now",
  schedule_tour_title: "Not at the property? Schedule a Tour!",
  schedule_tour_description: "Pick a community and check out the properties open for touring. Book a self-guided tour for a later date!",
  schedule_tour_button: "Schedule a Tour"
};

export const CONTENT_SETTINGS_ES_DEFAULT: BuilderContentSettings = {
  self_tour_scheduling_title: "Programación de auto-recorridos",
  self_tour_scheduling_subtitle: "¡hecha fácil!",
  self_tour_scheduling_description: "Encontrar su casa soñada está a solo unos pasos. Disfrute de un recorrido privado por nuestras hermosas casas nuevas en un momento que sea conveniente para usted.",
  how_it_works_title: "Cómo funciona",
  step_1_title: "Seleccione la casa",
  step_1_description: "Busque nuestras casas terminadas para ver cuáles ofrecen recorridos autoguiados.",
  step_2_title: "Verifique su identidad",
  step_2_description: "Cree una cuenta con una identificación válida y un número de teléfono.",
  step_3_title: "Elija la hora",
  step_3_description: "Seleccione 'Recorrer ahora' o programe para más tarde.",
  step_4_title: "Reciba código de acceso",
  step_4_description: "A la hora seleccionada, reciba un código de acceso y disfrute de su recorrido.",
  start_touring_button: "Comenzar recorrido",
  self_tours_own_time_title: "Auto-recorridos a su propio tiempo",
  tour_now_title: "¡Recorra ahora! Obtenga acceso inmediato",
  tour_now_description: "Una vez que esté en la propiedad, verifique su identidad, obtenga un código de acceso de un solo uso y disfrute de su recorrido por la casa.",
  tour_now_button: "Recorrer ahora",
  schedule_tour_title: "¿No está en la propiedad? ¡Programe un recorrido!",
  schedule_tour_description: "Elija una comunidad y consulte las propiedades disponibles para recorrer. ¡Reserve un recorrido autoguiado para una fecha posterior!",
  schedule_tour_button: "Programar un recorrido"
};
